import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../commons/texts';
import { hasPemissions } from '../../../commons/utils';

import { storeGetAllShiftTemplatesByPaginate } from '../../../store/shift_templates';

import { TablePlantillaTurnos } from './TablePlantillaTurnos';
import { CreatePlantillaTurnoModal } from './modals/CreatePlantillaTurnoModal';
import { BannerInfoPlantillaTurnos } from './components/BannerInfoPlantillaTurnos';

export const PlantillaTurnos = () => {
  const dispatch: any = useDispatch();
  const [openCreate, setOpenCreate] = React.useState(false);
  const [hasPermission, setHasPermission] = useState(true);
  const [canCreate, setCanCreate] = useState(false);

  const checkPermissions = async () => {
    const view = await hasPemissions(
      'modulo.thumano',
      'modulo.programador',
      'view',
      'modulo.programador.plantillas'
    );
    if (!view) setHasPermission(false);

    const create = await hasPemissions(
      'modulo.thumano',
      'modulo.programador',
      'create',
      'modulo.programador.plantillas'
    );
    if (create) setCanCreate(true);
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const reloadTable = () => {
    dispatch(storeGetAllShiftTemplatesByPaginate(1));
  };

  if (!hasPermission) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', mt: 5 }}>
        <Typography variant="h6" color="text.secondary">
          No tienes permisos para ver este contenido.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <BreadCrumbsAndTitle
            title="Plantilla Turnos"
            mainModule="Programador Inteligente"
            parent="Plantilla de turnos"
            action=""
            icon="ViewTimeline"
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <AlertsInformativos
              type={'info'}
              title={'info'}
              content={alertInformativo.plantillaTurnos}
            />
          </Typography>
        </Box>
        {canCreate && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setOpenCreate(true)}
          >
            Nueva Plantilla de Turnos
          </Button>
        )}
      </Box>

      <TablePlantillaTurnos />

      {openCreate && (
        <CreatePlantillaTurnoModal
          open={openCreate}
          setOpen={setOpenCreate}
          reloadTable={reloadTable}
        />
      )}

      <BannerInfoPlantillaTurnos />
    </Box>
  );
};
